import { render, staticRenderFns } from "./NetworkExpansion.vue?vue&type=template&id=2ac3c66b"
import script from "./NetworkExpansion.vue?vue&type=script&lang=js"
export * from "./NetworkExpansion.vue?vue&type=script&lang=js"
import style0 from "./NetworkExpansion.vue?vue&type=style&index=0&id=2ac3c66b&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ac3c66b')) {
      api.createRecord('2ac3c66b', component.options)
    } else {
      api.reload('2ac3c66b', component.options)
    }
    module.hot.accept("./NetworkExpansion.vue?vue&type=template&id=2ac3c66b", function () {
      api.rerender('2ac3c66b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sfe/CPPerformanceReport/components/NetworkExpansion.vue"
export default component.exports